/* eslint-disable no-restricted-syntax */
import { I18n } from 'react-redux-i18n';
import QRCodeConfigRequests from '../../server/QRCodeConfig';
import addNotification from '../../../components/notification';
import { addLoading, removeLoading } from './loading';

export const setQRCodeEAN = (value) => ({
  type: 'qr_code_EAN',
  payload: value,
});

export const setQRCodeLotNumber = (value) => ({
  type: 'qr_code_lot_number',
  payload: value,
});

export const setQRCodeExpirationDate = (value) => ({
  type: 'qr_code_expiration_date',
  payload: value,
});

export const setQRCodeManufacturingDate = (value) => ({
  type: 'qr_code_manufacturing_date',
  payload: value,
});

export const setQRCodeQuantity = (value) => ({
  type: 'qr_code_quantity',
  payload: value,
});

export const setQRCodeInitialProps = () => ({
  type: 'qr_code_initial_props',
});

export const getQRCodeConfig = (qrCodeConfigId) => async (dispatch) => {
  dispatch(addLoading());
  try {
    return await QRCodeConfigRequests.getQRCodeConfig(qrCodeConfigId);
  } finally {
    dispatch(removeLoading());
  }
};

export const getAllQRCodes = (qrCodeConfigId) => async (dispatch) => {
  dispatch(addLoading());
  try {
    return await QRCodeConfigRequests.getAllQRCodes(qrCodeConfigId);
  } finally {
    dispatch(removeLoading());
  }
};

export const getQRCodeConfigByCode = (qrCodeConfigCode) => async (dispatch) => {
  dispatch(addLoading());
  try {
    return await QRCodeConfigRequests.getQRCodeConfigByCode(qrCodeConfigCode);
  } finally {
    dispatch(removeLoading());
  }
};

export const createQRCodeConfig = (QRCodeConfig) => async (dispatch) => {
  dispatch(addLoading());
  try {
    return await QRCodeConfigRequests.createQRCodeConfig(QRCodeConfig);
  } finally {
    dispatch(removeLoading());
  }
};

export const updateQRCodeConfig = (QRCodeConfig) => async (dispatch) => {
  dispatch(addLoading());
  try {
    return await QRCodeConfigRequests.updateQRCodeConfig(QRCodeConfig);
  } finally {
    dispatch(removeLoading());
  }
};

export const deleteQRCodeConfig = (qrCodeConfigId) => async (dispatch) => {
  dispatch(addLoading());
  try {
    return await QRCodeConfigRequests.deleteQRCodeConfig(qrCodeConfigId);
  } finally {
    dispatch(removeLoading());
  }
};

const parseDateFromFormat = (value, format) => {
  if (typeof value !== 'string' || typeof format !== 'string') {
    return null;
  }

  const cleanValue = value.replace(/\D/g, '');

  const cleanFormat = format.toUpperCase().replace(/[^DMAY]/g, '');
  if (!cleanValue || !cleanFormat) {
    return null;
  }

  const groups = cleanFormat.match(/(D+|M+|A+|Y+)/g);
  if (!groups || !groups.length) {
    return null;
  }

  let index = 0;
  let day = '';
  let month = '';
  let year = '';

  for (const group of groups) {
    const { length } = group;
    const part = cleanValue.substr(index, length);

    switch (group[0]) {
      case 'D':
        day = part;
        break;

      case 'M':
        month = part;
        break;

      case 'A':
      case 'Y':
        year = part.length === 2 ? `20${part}` : part;
        break;

      default:
        break;
    }

    index += length;
  }

  day = day.padStart(2, '0');
  month = month.padStart(2, '0');

  return `${day}/${month}/${year}`;
};

export const translateQRCode = (qrCodeString, qrCodeConfig) => async (dispatch) => {
  dispatch(setQRCodeInitialProps());
  try {
    if (qrCodeString && qrCodeConfig) {
      const splitModel = qrCodeString.split(qrCodeConfig.separator);
      if (splitModel.length === 1) {
        dispatch(setQRCodeEAN(splitModel[0]));
        return;
      }
      const expirationDateFormated = qrCodeConfig.expirationDatePosition
        ? parseDateFromFormat(
          splitModel[qrCodeConfig.expirationDatePosition - 1],
          qrCodeConfig.expirationDateFormat,
        )
        : null;

      const manufacturingDateFormated = qrCodeConfig.manufacturingDatePosition
        ? parseDateFromFormat(
          splitModel[qrCodeConfig.manufacturingDatePosition - 1],
          qrCodeConfig.manufacturingDateFormat,
        )
        : null;

      dispatch(setQRCodeEAN(splitModel[qrCodeConfig.productCodePosition - 1] || ''));
      dispatch(setQRCodeLotNumber(splitModel[qrCodeConfig.lotNumberPosition - 1] || null));
      dispatch(setQRCodeExpirationDate(expirationDateFormated));
      dispatch(setQRCodeManufacturingDate(manufacturingDateFormated));
      dispatch(setQRCodeQuantity(splitModel[qrCodeConfig.quantityPosition - 1] || null));
    }
  } catch (err) {
    addNotification(
      'danger',
      I18n.t('BEE4590' /* Configurador de QR Code */),
      I18n.t('BEE4606' /* Leitura inválida! */),
      'top-right',
    );
  }
};
